<app-page-title [title]="'Sign In'"></app-page-title>
<div class="form-container">
    <div class="row">
        <div class="col-12 col-sm-6">
            <app-login-form></app-login-form>
        </div>
        <div class="col-12 col-sm-6 my-4">
            <app-feature-list></app-feature-list>
        </div>
    </div>
</div>
<app-cookies-notification></app-cookies-notification>
